<template>
  <div class="brackets-grid">
    <div>
      <div class="brackets-grid__container">
        <div class="brackets-grid__round" v-for="round of rounds" :key="round">
          <div
            class="brackets-grid__match"
            v-for="(pair, index) of pairs(round)"
            :key="index"
          >
            <BracketCard :match="pair[0]" />
            <BracketCard v-if="pair[1]" :match="pair[1]" />
          </div>
        </div>
        <div class="brackets-grid__round">
          <div class="brackets-grid__match">
            <BracketCard :match="winner" result />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BracketCard from "./BracketCard";

export default {
  components: {
    BracketCard
  },
  props: {
    gridData: { required: true },
    rounds: { type: Array, required: true }
  },

  computed: {
    lastMatch() {
      return this.gridData[1][0];
    },
    winner() {
      return this.lastMatch;
    }
  },

  methods: {
    pairs(round) {
      const key = Math.pow(2, round);
      const matches = this.gridData[key] || [];
      const pairs = [];

      for (let i = 0; i < matches.length; i += 2) {
        pairs.push([matches[i], matches[i + 1]]);
      }

      return pairs;
    }
  }
};
</script>

<style lang="scss">
.brackets-grid {
  &__container {
    display: inline-flex;
    align-items: stretch;
  }

  &__round {
    position: relative;
    width: 190px;
    display: flex;
    flex-direction: column;
    z-index: 1;
    margin-right: 30px;
  }

  &__match {
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1 0;
    align-items: center;
    min-height: 260px;
  }
}
</style>
